module.exports = __webpack_public_path__ + "img/gallery-image-34.26694f71.jpg";